var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row items-center cursor-pointer"},[_c('img',{attrs:{"src":require('@/assets/meitav-dash/combined-logo.svg'),"width":120,"height":"20"},on:{"click":_vm.openWebsite}})])}
var staticRenderFns = []

export { render, staticRenderFns }